import { Component, OnInit } from '@angular/core';
import { LambdaService } from 'src/app/lambda.service';
import { ThemingService } from 'src/app/theming.service';
import * as feather from 'feather-icons';

declare var $: any;

@Component({
  selector: 'app-shipping-costs',
  templateUrl: './shipping-costs.component.html',
  styleUrls: ['./shipping-costs.component.scss']
})
export class ShippingCostsComponent implements OnInit {
  loading = false;
  loadingShippingCost = false;
  shippingCost: number = 0;
  isEditingGeneral = false;
  loadingInfo = false;
  shippingType: string = '';
  editingRowId: number | null = null;
  newShippingRows: { type: string; cost: number }[] = [];

  constructor(
    private lambdaService: LambdaService,
    public themingService: ThemingService
  ) { }

  ngOnInit(): void {
    this.getShippingCosts();
  }

  ngAfterViewInit() {
    feather.replace();
  }

  addNewShippingRow() {
    this.newShippingRows.push({ type: '', cost: 0 });
  }

  cancelNewShippingRow(index: number) {
    this.newShippingRows.splice(index, 1);
  }

  switchEditingAll() {
    this.isEditingGeneral = true;
  }

  switchCancelEditingAll() {
    this.isEditingGeneral = false;
  }

  shippingCosts: { id: number; type: string; cost: number }[] = [];

  removeShippingCost(id: number) {
    this.deleteShippingCosts(id);
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  startEditing(id: number) {
    this.editingRowId = id;
  }

  cancelEditing() {
    this.editingRowId = null;
  }

  isEditing(id: number): boolean {
    return this.editingRowId === id;
  }

  getShippingCosts() {
    this.loadingShippingCost = true;
    this.lambdaService
      .getShippingCosts(this.themingService.shopId)
      .then((data: any) => {
        const result = Array.isArray(data) && Array.isArray(data[0]) && data[0][0]
          ? data[0][0]
          : null;

        this.shippingCosts = Array.isArray(data[0])
          ? data[0].map((item: any) => ({
            id: item.id,
            type: item.shippingType,
            cost: item.shippingCosts
          }))
          : [];

        this.loadingShippingCost = false;
      })
      .catch((error: Error) => {
        console.error(error);
        this.loadingShippingCost = false;
      });
  }

  createShippingCosts(row: { type: string; cost: number }, index: number) {
    this.loading = true;
    if (!row.type || row.cost <= 0) return;

    this.lambdaService.createShippingCosts(this.themingService.shopId, row.cost, row.type)
      .then(() => {
        this.loading = false;
        this.newShippingRows.splice(index, 1);
        this.getShippingCosts();
        $('#successCreateShippingModal').modal('show');
        $('#successCreateShippingModal').on('hidden.bs.modal', () => {
        });
      })
      .catch((error: Error) => {
        console.error(error);
        this.showErrorModal('create');
      });
  }

  updateShippingCosts(shipping: { id: number; type: string; cost: number }) {
    this.loading = true;
    this.lambdaService
      .updateShippingCosts(
        shipping.id,
        this.themingService.shopId,
        shipping.cost,
        shipping.type
      )
      .then(() => {
        console.log('Update successful, showing modal');
        this.loading = false;
        this.editingRowId = null;
        this.getShippingCosts();
        $('#successShippingCostsModal').modal('show');
        $('#successShippingCostsModal').on('hidden.bs.modal', () => { });

      })
      .catch((error: Error) => {
        console.error(error);
        this.showErrorModal('update');
      });
  }

  deleteShippingCosts(id: number) {
    this.loading = true;
    this.lambdaService
      .deleteShippingCosts(this.themingService.shopId, id)
      .then(() => {
        this.loading = false;
        this.isEditingGeneral = false;
        this.getShippingCosts();
        $('#successDeleteShippingCostsModal').modal('show');
        $('#successDeleteShippingCostsModal').on('hidden.bs.modal', () => { });
      })
      .catch((error: Error) => {
        console.error(error);
        this.showErrorModal('delete');
      });
  }

  closeModal() {
    $('#successShippingCostsModal').modal('hide');
    $('#successDeleteShippingCostsModal').modal('hide');
    $('#successCreateShippingModal').modal('hide');
    $('#errorCreateShippingModal').modal('hide');
    $('#errorShippingCostsModal').modal('hide');
    $('#errorDeleteShippingModal').modal('hide');
  }

  showErrorModal(context: 'create' | 'update' | 'delete'): void {
    if (context === 'create') {
      $('#errorCreateShippingModal').modal('show');
      $('#errorCreateShippingModal').on('hidden.bs.modal', () => { });
    } else if (context === 'update') {
      $('#errorShippingCostsModal').modal('show');
      $('#errorShippingCostsModal').on('hidden.bs.modal', () => { });
    } else if (context === 'delete') {
      $('#errorDeleteShippingModal').modal('show');
      $('#errorDeleteShippingModal').on('hidden.bs.modal', () => { });
    }
  }
}
